import * as React from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Button, Row, Col } from "reactstrap";
import { bindActionCreators, compose } from "redux";
import { systemAction } from "../../_actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class SystemDetail extends React.Component<{ data: any , editSystem: any}, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      id: this.props.data.id,
      name: this.props.data.name,
      serviceUrl: this.props.data.serviceUrl,
      token: this.props.data.token
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  handleValidSubmit(event: any, values: any) {
    this.setState({
      name: values.name,
      serviceUrl: values.serviceUrl,
      token: values.token
     });

    console.log(this.state);
    this.props.editSystem(this.state);
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <AvForm className="sypal-form" onValidSubmit={this.handleValidSubmit}>
          <AvField
            name="name"
            label={t("name")}
            value={this.props.data.name}
          />
          <AvField
            name="serviceUrl"
            label={t("url")}
            value={this.props.data.serviceUrl}
          />
          <AvField
            name="token"
            label={t("token")}
            value={this.props.data.token}
          />
          <Row style={{ justifyContent: "center" }}>
            <Col style={{ textAlign: "center" }} sm="12" md="4">
              <Button color="success" type="submit" className="w-100">
                {t("save")}
              </Button>
            </Col>
          </Row>
        </AvForm>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    systems: state.systems
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      editSystem: systemAction.editSystem
    },
    dispatch
  );
};

const SystemDetailComponent = compose(
  withTranslation('systems'),
  connect(mapStateToProps,mapDispatchToProps)
)(SystemDetail);

export { SystemDetailComponent as SystemDetail };